// Filters Reducer
const filtersReducerDefaultState = {
    fields: [true,true,true,true],
};
  
export default (state = filtersReducerDefaultState, action) => {
    switch (action.type) {
        case 'SORT_BY_FIELD':
        return {
            ...state,
            fields:action.fields
        };
        default:
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/filters.js